import { ListItem} from "@mui/material";
import { styled } from "@actinc/dls/helpers/styled";

export const StyledListItem = styled(ListItem)(({ theme }) => ({
    display: 'list-item', 
    paddingLeft: `${theme.spacing(0)}`
}));